
import { Button } from "@/components/ui/button";
import { PlusCircle, ViewIcon, AlertCircle } from "lucide-react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";

interface TaskHeaderProps {
  isBoard: boolean;
  viewMode: "my" | "all";
  onViewModeChange: (mode: "my" | "all") => void;
  onNewTask: () => void;
  pendingRequestsCount?: number;
}

const TaskHeader = ({ 
  isBoard, 
  viewMode, 
  onViewModeChange,
  onNewTask,
  pendingRequestsCount = 0
}: TaskHeaderProps) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between gap-4">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Tasks</h1>
        <p className="text-muted-foreground">
          Manage and monitor all tasks for the co-op.
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
        {isBoard && (
          <RadioGroup 
            defaultValue={viewMode} 
            className="flex items-center space-x-2"
            onValueChange={(value) => onViewModeChange(value as "my" | "all")}
          >
            <div className="flex items-center space-x-1">
              <RadioGroupItem value="my" id="my-tasks" />
              <Label htmlFor="my-tasks" className="cursor-pointer">My Tasks</Label>
            </div>
            <div className="flex items-center space-x-1">
              <RadioGroupItem value="all" id="all-tasks" />
              <Label htmlFor="all-tasks" className="cursor-pointer flex items-center gap-1">
                All Tasks
                {viewMode === "all" && pendingRequestsCount > 0 && (
                  <Badge className="bg-amber-100 text-amber-800 border-amber-200 ml-1">
                    <AlertCircle className="h-3 w-3 mr-1" /> {pendingRequestsCount}
                  </Badge>
                )}
              </Label>
            </div>
          </RadioGroup>
        )}
        {isBoard && (
          <Button onClick={onNewTask} className="ml-auto">
            <PlusCircle className="h-4 w-4 mr-2" /> New Task
          </Button>
        )}
      </div>
    </div>
  );
};

export default TaskHeader;
